import { Phone, MapPin, Mail } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const SERVICES = [
  "Traitement antirouille",
  "Polissage & céramique",
  "Cire haute performance",
  "Nettoyage intérieur & extérieur",
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black/60 backdrop-blur-xl">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <button data-testid="footer-logo" onClick={() => scrollToSection("#hero")} className="flex items-center gap-3 mb-5">
            <span className="h-8 w-8 rotate-45 border border-gold flex items-center justify-center">
              <span className="h-2 w-2 bg-gold" />
            </span>
            <span className="font-display font-bold uppercase tracking-widest text-sm">
              Premium <span className="text-gold">Autoshine</span>
            </span>
          </button>
          <p className="text-sm text-white/50 font-light leading-relaxed max-w-xs">
            Detailing automobile haut de gamme. L'excellence du fini, au service de votre véhicule.
          </p>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Nos services</h3>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s} className="text-sm text-white/60 flex items-center gap-3">
                <span className="h-1 w-1 rotate-45 bg-gold/70 inline-block" />
                {s}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Contact</h3>
          <a
            data-testid="footer-phone-link"
            href="tel:5142690261"
            className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors duration-300 mb-4"
          >
            <Phone size={15} className="text-gold" />
            <span className="font-medium">514-269-0261</span>
          </a>
          <a
            data-testid="footer-email-link"
            href="mailto:premium.autoshine.mtl@gmail.com"
            className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors duration-300 mb-4 break-all"
          >
            <Mail size={15} className="text-gold shrink-0" />
            <span className="font-medium">premium.autoshine.mtl@gmail.com</span>
          </a>
          <p className="flex items-start gap-3 text-sm text-white/60">
            <MapPin size={15} className="text-gold mt-0.5 shrink-0" />
            Drummondville, Québec et les environs — Centre-du-Québec
          </p>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/40">
          © 2026 Premium Autoshine — Tous droits réservés.
        </p>
        <p className="text-xs text-white/40">
          Detailing professionnel · Drummondville, QC · Mentions légales sur demande
        </p>
      </div>
    </div>
  </footer>
);
